var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.12 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1fba9c;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aj\\xE1nd\\xE9k"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.11 27.83 27.06 27.83 49.02 27.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49,30.68V57.82A3.17,3.17,0,0,1,45.84,61H8.29a3.18,3.18,0,0,1-3.18-3.18V30.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 16.31,
    width: 52.12,
    height: 11.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.42,3a6.69,6.69,0,0,1,0,9.44C37.81,15,27.07,16.3,27.07,16.3S28.37,5.56,31,3A6.69,6.69,0,0,1,40.42,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.7,3a6.69,6.69,0,0,0,0,9.44C16.31,15,27.05,16.3,27.05,16.3S25.75,5.56,23.14,3A6.69,6.69,0,0,0,13.7,3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.06,
    y1: 61,
    x2: 27.06,
    y2: 30.68
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "27.06 27.83 27.06 16.31 27.06 16.15"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftGreen);
export default __webpack_public_path__ + "static/media/giftGreen.6160b1b00c47e3409dc6c660c988cd45.svg";
export { ForwardRef as ReactComponent };